import React, { CSSProperties } from 'react';
import { colors } from '../constants';

interface Props {
  children: React.ReactNode;
  className?: string;
  color: string;
  id?: string;
  isOpen: boolean;
  style?: CSSProperties;
}

export const Alert = (props: Props): JSX.Element => {
  const { children, className, color, id, isOpen, style } = props;

  const alertStyles = (): CSSProperties => {
    let backgroundColor = colors.error.DEFAULT;
    let textColor = colors.raspberry.DEFAULT;

    if (color === 'success') {
      backgroundColor = colors.success.DEFAULT;
      textColor = colors.almostBlack.DEFAULT;
    } else if (color === 'warning') {
      backgroundColor = colors.warning.DEFAULT;
      textColor = colors.almostBlack.DEFAULT;
    }

    return {
      backgroundColor,
      color: textColor,
      margin: '0 auto',
      maxWidth: '100%',
      padding: '0.5rem 0.25rem',
    };
  };

  return (
    <div className={`mx-auto sm:px-4${className ? ` ${className}` : ''}`} style={{ ...alertStyles(), ...style, display: isOpen ? 'flex' : 'none' }}>
      <div className='container flex-wrap' id={id ?? undefined}>
        {children}
      </div>
    </div>
  );
};
